import { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { getRememberedEmail } from "@/lib/memberEmail";

/** "Already a member? Get your link" — emails the private membership page to the member's inbox. */
export function MemberLinkBox() {
  const [email, setEmail] = useState(getRememberedEmail());
  const [busy, setBusy] = useState(false);
  const ok = /\S+@\S+\.\S+/.test(email);

  const send = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await api.post("/memberships/send-link", { email: email.trim() });
      if (r.data.sent) toast.success(`We've emailed your membership page to ${r.data.to}`);
      else toast.error("No active membership for that email — join above, or call 310-422-0669");
    } catch (err) { toast.error(err?.response?.data?.detail || "Couldn't send the link — call 310-422-0669"); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={send} className="dg-card rounded-xl p-4 mt-10 flex flex-col sm:flex-row sm:items-end gap-3" data-testid="member-link-box">
      <label className="flex-1 block">
        <div className="dg-eyebrow mb-1">Already a member? Get your link</div>
        <input className="dg-input" type="email" placeholder="The email you joined with" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="member-link-email" autoComplete="email" />
      </label>
      <button type="submit" disabled={!ok || busy} className="dg-btn-ghost rounded-full px-5 py-2.5 text-sm flex items-center justify-center gap-2 disabled:opacity-40" data-testid="member-link-submit">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />} Email me my membership page
      </button>
    </form>
  );
}
